module.exports = __webpack_public_path__ + "static/media/NewyearCountDownImg.7d51ed1a.png";